import {
    ADMIN_DELETE_BlOGDETAILS_START,
    ADMIN_DELETE_BlOGDETAILS_SUCCESS,
    ADMIN_DELETE_BlOGDETAILS_ERROR
} from '../../constants';
import history from '../../core/history';
import showToaster from '../../helpers/showToaster';
import { getBlogDetails as query, deleteBlogDetailsMutation, updateBlogStatusMutation } from '../../lib/graphql';

export function deleteBlogDetails(id, currentPage) {
    return async (dispatch, getState, { client }) => {
        try {
            dispatch({
                type: ADMIN_DELETE_BlOGDETAILS_START,
                data: id
            });

            const { data } = await client.mutate({
                mutation: deleteBlogDetailsMutation,
                variables: { id },
                refetchQueries: [{ query, variables: { currentPage } }]
            });

            if (data?.deleteBlogDetails?.status == "200") {
                dispatch({
                    type: ADMIN_DELETE_BlOGDETAILS_SUCCESS,
                });
                showToaster({ messageId: 'deleteSuccess', toasterType: 'success' })
                history.push('/siteadmin/content-management');
                return { status: 200 };
            } else {
                showToaster({ messageId: 'deleteFailed', toasterType: 'error' })
            }
        } catch (error) {
            dispatch({
                type: ADMIN_DELETE_BlOGDETAILS_ERROR,
                payload: {
                    error
                }
            });
        }
    };
}

export function updateBlogStatus(id, isEnable, currentPage) {
    return async (dispatch, getState, { client }) => {
        try {
            const { data } = await client.mutate({
                mutation: updateBlogStatusMutation,
                variables: { id, isEnable: isEnable == 'false' || !isEnable},
                refetchQueries: [{ query, variables: { currentPage } }]
            });

            if (data?.updateBlogStatus?.status === "success") {
                showToaster({ messageId: 'updateStatus', toasterType: 'success' })
            }
        } catch (error) {
            showToaster({ messageId: 'updateFailed', toasterType: 'error' })
            return false;
        }
        return true;
    };
}